/* eslint-disable no-nested-ternary */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/extensions */
import { selfApi } from "@fdn/rtk_profile_store";
import Data from "Consts/data";
import Env from "Consts/env";
import * as ServerCookies from "cookies";
import * as metaPixel from "Helpers/fb-pixel";
import * as gtag from "Helpers/gtag";
import * as tiktokPixel from "Helpers/tiktok-pixel";
import {
	createCart,
	isProduction,
	mappingListCategory,
	mappingTopNavigationDesktop,
	ScrollToUp,
} from "Helpers/utils";
import Cookies from "js-cookie";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { END } from "redux-saga";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { categoryApiSlice, useGetCategoryListQuery } from "@/Store/rtk-query/feature/service/categoryApiSlice";
import { brandsApiSlice, useGetListBrandsQuery } from "@/Store/rtk-query/feature/service/brandApiSlice";
import { apiSlice } from "@/Store/rtk-query/feature/api/apiSlice";
import { wrapper } from "@/Store/index";
import { useGetProductListQuery, useGetQuickReviewProductQuery } from "@/Store/rtk-query/feature/service/productApiSlice";

const Mobile = dynamic(() => import("./mobile"));
const Desktop = dynamic(() => import("./desktop"));
const Layout = dynamic(() => import("Containers/layout"), { ssr: false });
const Drawer = dynamic(() => import("Components/drawer"), { ssr: false });
const Loader = dynamic(() => import("@fdn/loader"), { ssr: false });
const Popup = dynamic(() => import("Components/pdp-popup"), { ssr: false });
const AddToCartPopup = dynamic(() => import("Components/add-to-cart-popup"), { ssr: false });
const ModalQuickReview = dynamic(() => import("Components/modal-quick-review"), { ssr: false });
const ChildDetailQuickReview = dynamic(() => import("Containers/child-detail-quick-review"), { ssr: false });

const Slug = (props) => {

	const data = props;

	const router = useRouter();
	const {
		slug, onSale, page, ...routerQuery
	} = router?.query || data?.query;

	const [isShowFilter, setShowFilter] = useState(false);
	const [isShowSorter, setShowSorter] = useState(false);
	const dispatch = useDispatch();

	const [filter, setFilter] = useState({
		category: routerQuery?.category ? routerQuery?.category?.split(",") : [],
		minPrice: routerQuery?.maxPrice ?? "",
		maxPrice: routerQuery?.minPrice ?? "",
		onSale: routerQuery?.onSale ?? "",
	});

	const [showCategoryFilter, setShowCategoryFilter] = useState(false);
	const [showAllCategories, setShowAllCategories] = useState(false);
	const [quickReviewItem, setQuickReviewItem] = useState("");
	const [isModalQuickReview, setModalQuickReview] = useState(false);

	const {
		data: dataListBrands,
		// isLoading: loadingDataListBrands,
	} = useGetListBrandsQuery({
		headers: {
			slug: slug || null,
		},
		params: {
			isDirect: false,
		},
	});

	const {
		data: quickReviewData,
		isLoading: loadingGetQuickReview,
		isFetching: fetchingGetQuickReview,
	} = useGetQuickReviewProductQuery(quickReviewItem ? { params: quickReviewItem } : skipToken);

	const getProductQuery = {
		page: page || "1",
		limit: data.isMobile ? "8" : "16",
		category: routerQuery?.category?.split(",").filter((item) => item),
		brand: dataListBrands?.data?.brand_id ?? "",
		sort: routerQuery?.sort || "",
		placement: routerQuery?.routerQuery?.length > 0 ? 3 : 2,
		query: routerQuery?.query || "",
	};

	const { data: dataProducts, isLoading: loadingDataProduct, isFetching } = useGetProductListQuery({
		params: {
			...getProductQuery,
			...(onSale === "true" ? { sale: "1" } : {}),
			...(routerQuery.min_price && { min_price: routerQuery.min_price }),
			...(routerQuery.max_price && { max_price: routerQuery.max_price }),
		},
	});

	const {
		data: dataCategoryDesktop,
	} = useGetCategoryListQuery({ placement: 2 });

	const topNavigationData = React.useMemo(
		() => mappingTopNavigationDesktop(dataCategoryDesktop), [dataCategoryDesktop],
	);

	const listCategory = React.useMemo(
		() => mappingListCategory(topNavigationData, routerQuery), [topNavigationData],
	);

	const [popupShow, setPopupShow] = useState({
		show: false,
		message: "",
		color: "#323942",
		redirect: false,
		closable: false,
	});
	const [addToCartLoading, setAddToCartLoading] = useState(false);
	const [addToCartPopupShow, setAddToCartPopupShow] = useState({
		show: false,
		addedProduct: {},
		productId: 0,
	});

	const HandleLoadMore = async (e) => {

		try {

			const searchParams = new URLSearchParams({
				...routerQuery,
				page: e,
			});
			router.push(`${slug}?${searchParams.toString()}`, undefined, { shallow: true });
			ScrollToUp();

		} catch (err) {

			setPopupShow({
				show: true,
				message: "Something went wrong. Please try again later.",
				color: "#323942",
			});

		}

	};

	const loader = useRef(null);

	const HandleFilter = (type, val, input) => {

		if (data?.isMobile) {

			let temp = val;
			if (!input) {

				temp = Array.isArray(val) ? val : [...filter[type], val];

			}

			setFilter({
				...filter,
				[type]: temp,
			});

		} else {

			let temp = val;
			if (!input) {

				const arrayFilter = routerQuery?.[type]?.split(",");
				temp = Array.isArray(val) ? val : [...(arrayFilter || []), val];

			}

			const searchParams = new URLSearchParams({
				...routerQuery,
				[type]: temp,
			});

			router.push(`${slug}?${searchParams.toString()}`, undefined, { shallow: true });

		}

	};

	const HandleFilterRemove = (type, val) => {

		if (!data.isMobile) {

			const searchParams = new URLSearchParams({
				...routerQuery,
				[type]: type === "onSale" ? val : routerQuery[type].split(",")?.filter((i) => (
					i !== val && i !== val?.id && i !== val?.slug
				)),
			});
			router.push(`${slug}?${searchParams.toString()}`, undefined, { shallow: true });

		}

	};

	const HandleFilterReset = () => {

		setFilter({
			category: [],
			minPrice: "",
			maxPrice: "",
			onSale: false,
		});

		if (!data.isMobile) {

			router.push(`${slug}?page=1`, undefined, { shallow: true });

		}

	};

	const HandleSave = () => {

		const searchParams = new URLSearchParams({
			...filter,
			onSale: data?.isMobile ? filter?.onSale : onSale,
			sort: routerQuery?.sort || "",
			page: 1,
		});
		router.push(`${slug}?${searchParams.toString()}`, undefined, { shallow: true });
		setShowFilter(false);

	};

	const HandleSorting = async (params) => {

		const searchParams = new URLSearchParams({
			...routerQuery,
			onSale,
			sort: params,
		});
		router.push(`${slug}?${searchParams?.toString()}`, undefined, { shallow: true });

	};

	/* START FUNC HANDLE QUICK REVIEW & ADD TO CART */
	const HandleQuickReview = async (params) => {

		setQuickReviewItem(params);
		setModalQuickReview(true);

	};

	const HandleAddCart = (item) => {

		setPopupShow({
			show: false,
			message: "",
			color: "#323942",
			closable: false,
			redirect: false,
		});
		setAddToCartLoading(true);

		const quoteID = Cookies.get("quoteId");
		const authSso = Cookies.get("token");

		if (!authSso && !quoteID) {

			setPopupShow({
				show: true,
				message: "Mohon refresh halaman ini",
				color: "#FF4D4F!important",
				closable: false,
				redirect: true,
			});

		} else {

			createCart({
				data: {
					sku: item.sku,
					qty: "1",
				},
			})
				.then((resp) => {

					if (
						resp?.status >= 200
						&& resp?.status < 300
						&& resp?.data?.data?.item_id
					) {

						if (isProduction) {

							tiktokPixel.track("AddToCart", {
								content_name: resp.data.data.name,
								content_type: "product",
								brand: item.brands.brand_name,
								sku: resp.data.data.sku,
								content_ids: [resp.data.data.item_id],
								value: resp.data.data.price,
								currency: "IDR",
								qty: resp.data.data.qty,
							});

							metaPixel.standardEvent("AddToCart", {
								content_name: resp.data.data.name,
								content_type: "product",
								brand: item.brands.brand_name,
								sku: resp.data.data.sku,
								content_ids: [resp.data.data.item_id],
								value: resp.data.data.price,
								currency: "IDR",
								qty: resp.data.data.qty,
							});

							gtag.event({
								eventName: "add_to_cart",
								parameter: {
									id: resp.data.data.item_id,
									name: resp.data.data.name,
									brand: item.brands.brand_name,
									sku: resp.data.data.sku,
									value: resp.data.data.price,
									currency: "IDR",
									quantity: resp.data.data.qty,
									event_category: "add_to_cart",
									event_label: "add_to_cart",
								},
							});

						}

						dispatch(apiSlice.util.invalidateTags(["Products"]));

						return resp;

					}

					if (resp?.data?.meta?.msg === "The requested qty is not available") {

						return setPopupShow({
							show: true,
							message: "Orderan anda melebihi jumlah stock",
							color: "#FF4D4F",
							closable: true,
							redirect: false,
						});

					}
					if (
						!authSso
						&& resp?.data?.meta?.msg === "The consumer isn't authorized to access %resources."
					) {

						return setPopupShow({
							show: true,
							message: "Silahkan anda login terlebih dahulu",
							color: "#FF4D4F",
							closable: true,
							redirect: false,
						});

					}

					throw new Error(resp?.data?.meta?.msg);

				})
				.then(async (resp) => {

					if (resp?.status >= 200
						&& resp?.status < 300
						&& resp?.data?.data?.item_id
					) {

						setAddToCartPopupShow({
							show: true,
							addedProduct: {
								...resp.data.data,
								requested_qty: 1,
							},
							productId: item.id,
						});

					}

				})
				.catch((err) => {

					// console.log(`Error add cart : ${err}`);
					setPopupShow({
						show: true,
						message: `${err.message}`,
						color: "#FF4D4F !important",
						closable: true,
						redirect: false,
					});

				})
				.finally(() => {

					setAddToCartLoading(false);

				});

		}

	};

	/* END FUNC HANDLE QUICK REVIEW & ADD TO CART */

	const brandDetailName = dataListBrands?.data?.brand_name ?? "";
	return (
		<Layout
			home
			title="Femaledaily"
			typeNavbarSecondary="type-1"
			titleNavbar={brandDetailName}
			ismobile={data.isMobile}
			self={data?.getStoreSelf}
			categoryDesktop={topNavigationData}
			getQuoteIdErrMessage={data.getQuoteIdErrMessage}
			metaDescription={
				data
				&& (dataListBrands?.data?.Meta?.meta_description
					|| `Jual Produk ${brandDetailName} Asli dan Lengkap di FD Studio by Female Daily.`)
			}
			metaKeywords={data && dataListBrands?.data?.Meta?.meta_keywords}
			metaTitle={
				data
				&& (dataListBrands?.data?.Meta?.meta_title?.split("|")[0]
					|| `Belanja Online ${brandDetailName}`)
			}
		>
			{data.isMobile ? (
				<Mobile
					isLoading={
						Object.keys(dataListBrands?.data ?? {}).length > 0
						&& (loadingDataProduct || isFetching)
					}
					data={dataListBrands?.data}
					slug={routerQuery && dataListBrands?.data.brand_name}
					showFilter={isShowFilter}
					handleShowFilter={(val) => {

						setFilter({
							...routerQuery,
							...(routerQuery?.category ? { category: routerQuery?.category?.split(",").filter((item) => item) } : { category: [] }),
							onSale: onSale === "true",
							minPrice: routerQuery?.minPrice || "",
							maxPrice: routerQuery?.maxPrice || "",
						});
						setShowFilter(val);

					}}
					showSorter={isShowSorter}
					handleShowSorter={(val) => setShowSorter(val)}
					filter={filter}
					handleFilter={(type, val, input) => HandleFilter(type, val, input)}
					handleRemove={(type, val) => HandleFilterRemove(type, val)}
					handleSave={HandleSave}
					categories={listCategory}
					sale={routerQuery?.onSale === "true"}
					sorting={Data.SORT_BY}
					sortingSelected={routerQuery?.sort || ""}
					handleSetSorting={(val) => HandleSorting(val)}
					listProducts={dataProducts?.data?.products}
					loader={loader}
					handleFilterReset={HandleFilterReset}
					totalPage={dataProducts?.pagination?.totalPage}
					page={page || 1}
					handleLoadMore={
						Object.keys(dataListBrands?.data || {}).length > 0
							? (val) => HandleLoadMore(val)
							: () => { }
					}
				/>
			) : (
				<Desktop
					isLoading={loadingDataProduct || isFetching}
					total={dataProducts?.pagination?.total}
					data={dataListBrands?.data}
					slug={routerQuery && dataListBrands?.data?.brand_name}
					listProducts={dataProducts?.data?.products}
					showSorter={isShowSorter}
					handleShowSorter={(val) => setShowSorter(val)}
					sorting={Data.SORT_BY}
					sortingSelected={routerQuery?.sort || ""}
					handleSetSorting={(val) => HandleSorting(val)}
					handleQuickReview={HandleQuickReview}
					HandleAddCart={HandleAddCart}
					filter={{
						...routerQuery,
						...(routerQuery?.category ? { category: routerQuery?.category?.split(",").filter((item) => item) } : { category: [] }),
						onSale: onSale === "true",
						minPrice: routerQuery?.minPrice || "",
						maxPrice: routerQuery?.maxPrice || "",
					}}
					handleFilter={(type, val, input) => HandleFilter(type, val, input)}
					handleFilterRemove={(type, val) => HandleFilterRemove(type, val)}
					setShowCategoryFilter={(val) => setShowCategoryFilter(val)}
					showCategoryFilter={showCategoryFilter}
					showAllCategories={showAllCategories}
					setShowAllCategories={(val) => setShowAllCategories(val)}
					categoriesMenu={listCategory}
					loader={loader}
					handleFilterReset={HandleFilterReset}
					totalPage={dataProducts?.pagination?.total_page}
					page={page || 1}
					handleLoadMore={
						Object.keys(dataListBrands?.data || {}).length > 0
							? (val) => HandleLoadMore(val)
							: () => { }
					}
				/>
			)}

			{addToCartLoading && (
				<>
					<div className="fdn-loader">
						<Loader />
					</div>
					<style>
						{`
								.fdn-loader {
									position:absolute;
								}
							`}
					</style>
				</>
			)}
			<Popup
				isMobile={data.isMobile}
				color={popupShow?.color}
				show={popupShow?.show}
				onHide={() => {

					setPopupShow(false);

					if (popupShow?.redirect) {

						window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/my/account`;

					}

				}}
				closable={popupShow?.closable}
				text={popupShow?.message}
				withOk={false}
			/>
			<ModalQuickReview
				show={isModalQuickReview}
				onClick={() => setModalQuickReview(false)}
				closable
			>
				<ChildDetailQuickReview
					data={{
						...quickReviewData?.data?.product,
					}}
					isLoading={loadingGetQuickReview || fetchingGetQuickReview}
					closeModal={() => setModalQuickReview(false)}
					setPopupShow={(e) => setPopupShow(e)}
					setAddToCartLoading={(e) => setAddToCartLoading(e)}
					setAddToCartPopupShow={(e) => setAddToCartPopupShow(e)}
				/>
			</ModalQuickReview>

			<Drawer
				isMobile={false}
				contentBackground="#FFF"
				title="Added to Cart!"
				headerIconSrc="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/fdn-studio-new/static/added-to-cart.png"
				onHide={() => setAddToCartPopupShow((prev) => ({
					show: false,
					addedProduct: prev.addedProduct,
					productId: prev.productId,
				}))}
				type="with-overlay"
				show={addToCartPopupShow?.show}
			>
				<AddToCartPopup
					isMobile={false}
					addedProduct={addToCartPopupShow?.addedProduct}
					productId={addToCartPopupShow?.productId}
				/>
			</Drawer>

		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({
		store, req, res: resServer, query,
	}) => {

		let userAgent;
		let authorization = null;

		let sorting = null;

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const Cookie = new ServerCookies(req, resServer);

		if (req.headers.cookie) {

			authorization = Cookie.get("token");

		}

		const getUserQuery = {
			api_env: process.env.NEXT_PUBLIC_NODE_ENV,
			env: Env.HEADERS,
			Authorization: authorization || null,
			is_server: true,
		};

		await Promise.all([
			store.dispatch(
				selfApi.endpoints.loadSelf.initiate(getUserQuery),
			),
			store.dispatch(
				categoryApiSlice.endpoints.getCategoryList.initiate({ placement: 2 }),
			),
			store.dispatch(
				brandsApiSlice.endpoints.getListBrands.initiate({
					headers: {
						slug: query?.slug,
					},
				}),
			),
		]);

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const state = store.getState();

		const getStoreSelf = selfApi.endpoints.loadSelf.select(getUserQuery)(state);

		// const categoryNavigationDesktop = [];

		if (query?.sort) {

			sorting = query.sort;

		}
		return {
			props: {
				query,
				sorting,
				isMobile,
				getStoreSelf: getStoreSelf?.data?.data || null,
				getQuoteIdErrMessage: null,
			}, // will be passed to the page component as props
		};

	},
);

export default Slug;
